<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		viewBox="0 0 26 26"
	>
		<g
			fill="none"
			fill-rule="evenodd"
			transform="translate(1 1)"
		>
			<circle
				cx="12"
				cy="12"
				r="12"
				fill="#FFD879"
				stroke="#E2C172"
			/>
			<circle
				cx="7.622"
				cy="9.243"
				r="2.108"
				fill="#3C5396"
			/>
			<circle
				cx="16.054"
				cy="9.243"
				r="2.108"
				fill="#3C5396"
			/>
			<path
				stroke="#3C5396"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
				d="M16.77 17.885s-1.424-2.642-4.818-2.642c-3.394 0-4.817 2.642-4.817 2.642"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: 26,
		},
		height: {
			type: [Number, String],
			default: 26,
		},
	},
};
</script>
